'use client';

import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { LanguageCode } from '@/hotdesk-ui/constants/langulage.constant';
import { fetchRemoteConfig, firebaseAnalytics } from '@/hotdesk-ui/common-classes/firebase.service';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import Information from './Information';
import Popup from '../cal-popup/Popup';
import { useCalculatorContext } from '../CalculatorContext';
import { useAppDispatch, useAppSelector } from '@/hotdesk-ui/hooks/hook';
import { setFormData } from '@/hotdesk-ui/store/slices/calculator.slice';
import { RootState } from '@/hotdesk-ui/store/store';
interface InformationClientWrapperProps {
  languageCode: LanguageCode;
}
type Country = {
  id: number;
  name_en: string;
  currency: string;
};
type currency = {
  value: string;
  label: string;
};
const InformationClientWrapper: FC<InformationClientWrapperProps> = ({
  languageCode
}) => {
  const router = useRouter();
  const [countryList, setCountryList] = useState<Country[]>([]);
  const [curencyList, setCurrencyList] = useState<currency[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useAppDispatch();
  const formData = useAppSelector((state: RootState) => state.calculator?.formData);
  const {
    setProgress
  } = useCalculatorContext();
  const {
    setCountry
  } = useCalculatorContext();
  const onSubmit = async (data: any) => {
    dispatch(setFormData(data));
    firebaseAnalytics('next_button_clicked');
    firebaseAnalytics('initail_infirmation', {
      country: data.country,
      number_of_employees: data.employees,
      WFO: data.workingDays,
      budget: data.budget,
      currency: data.curency
    });
    router.push('calculator/contact');
  };
  useEffect(() => {
    firebaseAnalytics('page_view', {
      page_name: 'calculator'
    });
  }, []);
  useEffect(() => {
    getRemoteConfig();
    setProgress(0);
  }, [languageCode]);
  useEffect(() => {
    if (!formData?.budget) {
      setIsOpen(true);
    }
  }, [formData]);
  const getRemoteConfig = async () => {
    try {
      let countryList = await fetchRemoteConfig(RemoteConfigKeys.ACTIVE_COUNTRY_LIST, 'object');
      setCountryList(countryList as {
        id: number;
        name_en: string;
        currency: string;
      }[]);
      setCurrencyList([{
        value: 'USD',
        label: 'USD'
      }]);
    } catch (error) {
      console.error(error);
    }
  };
  return <>
            <Information onSubmit={onSubmit} countryList={countryList} curencyList={curencyList} formData={formData} setCountry={setCountry} data-sentry-element="Information" data-sentry-source-file="InformationClientWrapper.tsx" />
            <Popup show={isOpen} handleClose={() => {
      setIsOpen(false);
    }} data-sentry-element="Popup" data-sentry-source-file="InformationClientWrapper.tsx" />
        </>;
};
export default InformationClientWrapper;